export default "__VITE_ASSET__Ddg29Tvg__"